import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'input-error-output',
  templateUrl: './input-error-output.component.html',
  styleUrls: ['./input-error-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputErrorOutputComponent {

  @Input() public control?: FormControl<any> | AbstractControl;
  @Input() public customErrorMessage?: string;

}
